'use strict';

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
	if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object' && (typeof module === 'undefined' ? 'undefined' : _typeof2(module)) === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define("tracker", [], factory);else if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object') exports["tracker"] = factory();else root["tracker"] = factory();
})(undefined, function () {
	return (/******/function (modules) {
			// webpackBootstrap
			/******/ // The module cache
			/******/var installedModules = {};
			/******/
			/******/ // The require function
			/******/function __webpack_require__(moduleId) {
				/******/
				/******/ // Check if module is in cache
				/******/if (installedModules[moduleId])
					/******/return installedModules[moduleId].exports;
				/******/
				/******/ // Create a new module (and put it into the cache)
				/******/var module = installedModules[moduleId] = {
					/******/exports: {},
					/******/id: moduleId,
					/******/loaded: false
					/******/ };
				/******/
				/******/ // Execute the module function
				/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
				/******/
				/******/ // Flag the module as loaded
				/******/module.loaded = true;
				/******/
				/******/ // Return the exports of the module
				/******/return module.exports;
				/******/
			}
			/******/
			/******/
			/******/ // expose the modules object (__webpack_modules__)
			/******/__webpack_require__.m = modules;
			/******/
			/******/ // expose the module cache
			/******/__webpack_require__.c = installedModules;
			/******/
			/******/ // __webpack_public_path__
			/******/__webpack_require__.p = "/build/";
			/******/
			/******/ // Load entry module and return exports
			/******/return __webpack_require__(0);
			/******/
		}(
		/************************************************************************/
		/******/[
		/* 0 */
		/***/function (module, exports, __webpack_require__) {

			/**
    * 数据埋点
    * @module tracker
    * @author lanmeng.bhy & shuke.cl
    * @date 2015-01-20
    */

			/**
    * 数据发送说明
    * 1. 为保证性能sendLogs() 方法在onload 50ms之后可以立即发送，在这之前的所有数据只采集，不发送
    */
			"use strict";

			Object.defineProperty(exports, "__esModule", {
				value: true
			});

			var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
				return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
			} : function (obj) {
				return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
			};

			var Tracker = function (document) {

				var WIN = window;
				var UA = navigator.userAgent;
				var PERFORMANCE_INFO = {};
				/*var IS_ALI_TRIP = (/AliTrip/i).test(UA);
    var IS_TB = !!((UA.match(/WindVane/i) && !UA.match(/T-UA/i)));
    var IS_TMALL = UA.match(/AliApp\(TM\//igm);
    var IS_ALITRIP = !!UA.match(/Alipay/ig);
     var android = UA.match(/(Android);?[\s\/]+([\d.]+)?/);
    var ipad = UA.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = UA.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && UA.match(/(iPhone\sOS)\s([\d_]+)/);*/

				WIN.trackerPerformanceTime = WIN.trackerPerformanceTime || { trip_startTime: new Date().getTime() }; //开发模式下可能没有头部时间戳
				var PROTOCOL = location.protocol == 'https:' ? 'https:' : 'http:';
				var LOG_HOST = PROTOCOL + '//wgo.mmstat.com/';
				var MAX_GET_REQUEST_LEN = 4000; //最大请求长度,用于拆分请求 http://wapp.m.taobao.com/market/trip/test-request-get-maxlength.html?host=h5.m.taobao.com
				var PAGE_START_TIME = window.trackerPerformanceTime.trip_startTime || new Date().getTime(); //进入页面时的时间
				var CUSTOM_PREFIX = "_";

				var _sendIndex = 0; //timelines被发送的次数
				var _cacheErr = {}; //缓存错误类型
				var _hiddenTime = null; //统计WEBVIEW被隐藏的耗时
				var _hiddenTimes = [];

				var isWindVane = /WindVane/i.test(UA);
				var _isSendUnloadLog = false;

				var BASE_GOLD_KEY = {
					/*performance: {
         key      : 'tbtrip.1000.1',
         checkCode: 'H46836965'
     },*/

					/**
      * 性能统计专用埋点
      */
					timeline: {
						key: 'tbtrip.1000.8',
						checkCode: 'H46836993'
					},
					/*
     customPerformance: {
         key      : 'tbtrip.1000.5',
         checkCode: 'H46836990'
     },*/
					/**
      * 自动监测的JS报错提示埋点
      */
					normalError: {
						key: 'tbtrip.1000.2',
						checkCode: 'H46836987'
					},
					/**
      * 自定错误埋点
      */
					/*customError: {
         key      : 'tbtrip.1000.3',
         checkCode: 'H46836988'
     },*/

					/*leavePage: {
         key      : 'tbtrip.1000.4', //停留时长
         checkCode: 'H46836989'
     },*/

					userAction: {
						key: 'tbtrip.2001.1.1',
						checkCode: 'H46896547'
					}
				};

				/**
     * 转换为数字
     * @param s
     * @returns {Number}
     */
				var numberify = function numberify(s) {
					var c = 0;
					/* convert '1.2.3.4' to 1.234 */
					return parseFloat(s.replace(/\./g, function () {
						return c++ === 0 ? '.' : '';
					}));
				};
				/**
     * 对象拷贝,不支持深拷贝
     * @param r 源对象
     * @param s 被拷贝对象
     * @param o 是否强制覆盖,默认false
     * @param prefix 属性是否增加同意前缀
     * @param isOwn 必须为自己私有属性
     * @returns {*}
     */
				var mix = function mix(r, s, o, prefix, isOwn) {
					isOwn = typeof isOwn !== 'undefined' ? isOwn : true;
					prefix = prefix || '';
					if (r && s) {
						for (var k in s) {
							isOwn = isOwn ? s.hasOwnProperty(k) : true;
							if (isOwn && (o || typeof r[k] === 'undefined')) {
								r[prefix + k] = s[k];
							}
						}
					}

					return r;
				};
				var contains = function contains(contentBox, subElement) {
					return contentBox.contains ? contentBox != subElement && contentBox.contains(subElement) : !!(contentBox.compareDocumentPosition(subElement) & 16);
				};
				/**
     * 判断是否为对象
     * @param obj
     * @returns {boolean}
     */
				var isObject = function isObject(obj) {
					var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
					return type === 'function' || type === 'object' && !!obj;
				};
				/**
     * 取得 cookie 中对应 key 的值
     * @param key {String}
     */
				var getCookie = function getCookie(key) {
					var cookie_val = document.cookie.match(new RegExp("\\b" + key + "=([^;]+)"));
					return cookie_val ? cookie_val[1] : "";
				};

				/**
     * 定义Tracker类
     * @param config
     * @constructor
     */
				function Tracker(config) {
					this._init();
				}

				Tracker.prototype = {
					version: "0.5.13",
					_init: function _init() {

						var self = this;
						self.markObj = {};
						self._timelineMap = {};
						self._timelines = [];
						self._isInteractCompleted = false;
						self._isRenderCompleted = false;
						PERFORMANCE_INFO.pushVersion = self._getPushVersion();
						self._saveNetstat();
						self._bind();
					},
					/**
      * 调试工具
      * @private
      */
					_debugTouchEvent: function _debugTouchEvent() {
						var screenWidth = screen.width;
						var screenHeight = screen.height;
						var isDev = false;
						//兼容android
						if (/Android/i.test(navigator.userAgent) && WIN.innerWidth) {
							screenWidth = WIN.innerWidth;
							screenHeight = WIN.innerHeight;
						}
						if (WIN.MT && WIN.MT.trackerDev) {
							isDev = true;
						}

						//TODO tracker 在base中构建时路径中的反斜线有bug
						var s = '/';
						var regx = /@/g;
						var jsPath = '@@g.alicdn.com@mpi@tracker-tool@index-min.js?t='.replace(regx, s) + Date.now();
						var cssPath = '@@g.alicdn.com@mpi@tracker-tool@index-min.css?t='.replace(regx, s) + Date.now();
						var insertTools = function insertTools() {
							//js
							var head = document.querySelector('head');
							var _script = document.createElement('script');
							_script.src = jsPath;
							_script.defer = true;
							head.appendChild(_script);
							//css
							var styleSheet = document.createElement("link");
							styleSheet.rel = "stylesheet";
							styleSheet.href = cssPath;
							head.appendChild(styleSheet);

							document.removeEventListener('touchmove', _hanlder);
						};
						var _hanlder = function _hanlder(e) {
							if (!e.touches) {
								return;
							}
							if (e.touches.length > 2) {
								// 第一个手指在屏幕左上角，第二个手指在屏幕左下角触发，第三个手指在品目右下角触发
								/*alert('device:' + window.devicePixelRatio +'\n\r' +
              'screen:' + screenWidth + '-' + screenHeight + '\n\r'+
              'touche' + e.touches[1].screenX + '-' +  e.touches[1].screenY);*/
								if (e.touches[0].screenX < screenWidth / 4 && e.touches[0].screenY < screenHeight / 4 && e.touches[1].screenX < screenWidth / 4 && e.touches[1].screenY > screenHeight * 0.75 && e.touches[2].screenX > screenWidth * 0.75 && e.touches[2].screenY > screenHeight * 0.75) {
									insertTools();
								}
							}
						};
						if (window.sessionStorage && window.sessionStorage.getItem && window.sessionStorage.getItem('__TRACKER_DEBUG_ENABLE') == '1') {
							//通过sessionStorage打开调试工具
							insertTools();
						} else {
							document.addEventListener('touchmove', _hanlder);
						}
					},
					_bind: function _bind() {
						WIN.addEventListener('beforeunload', this._beforeunloadHanlder.bind(this));
						WIN.addEventListener('pagehide', this._beforeunloadHanlder.bind(this));
						WIN.addEventListener('error', this._errorHandler.bind(this));
						WIN.addEventListener('DOMContentLoaded', this._domContentLoadedHandler.bind(this));
						document.addEventListener('visibilitychange', this._visibilitychangeHandler.bind(this));
						document.addEventListener('WV.Event.APP.Background', this._beforeunloadHanlder.bind(this)); //手淘锁屏切换窗口
						document.addEventListener('wvBackClickEvent', this._beforeunloadHanlder.bind(this)); //手淘回退
						document.addEventListener('pause', this._beforeunloadHanlder.bind(this)); //支付宝锁屏
						document.addEventListener('back', this._beforeunloadHanlder.bind(this)); //支付宝回退

						this._watch(WIN, 'Bridge,AlipayJSBridge,WindVane', this._watchGlobalHandler.bind(this));
						//兼容页面已经onload之后tarcker才被初始化的情况 http://work.taobao.net/issues/38828#note-14
						if (document.readyState === 'complete') {
							this._loadHandler();
						} else {
							WIN.addEventListener('load', this._loadHandler.bind(this));
						}
						try {
							this._debugTouchEvent();
						} catch (e) {}
					},
					_domContentLoadedHandler: function _domContentLoadedHandler() {
						WIN.trackerPerformanceTime.readyTime = new Date().getTime();
						//this.log('domComplete'   , null, null, 'domComplete');
					},
					_watchGlobalHandler: function _watchGlobalHandler(val, prop) {
						this._saveNetstat();
					},
					/**
      * 对window下的全局变量进行监听
      * @private
      */
					_watch: function _watch(obj, props, fn) {
						props.split(',').forEach(function (prop) {
							if (typeof obj[prop] === 'undefined') {
								Object.defineProperty(obj, prop, {
									enumerable: true,
									configurable: true,
									set: function (val) {
										//hack 先干掉针对该属性的setter/getter,恢复其存储功能
										delete obj[prop];
										obj[prop] = val;
										fn.call(this, val, prop);
									}.bind(this)
								});
							}
						});
					},
					_loadHandler: function _loadHandler() {
						var self = this;
						WIN.trackerPerformanceTime.loadTime = WIN.trackerPerformanceTime.loadTime || new Date().getTime();
						//this.log('loadComplete'  , null, null, 'loadComplete');
						setTimeout(function () {
							if (!self._isInteractCompleted) {
								self.sendLogs(true);
								self._autoSendLog();
							}
						}, 50);
					},
					_visibilitychangeHandler: function _visibilitychangeHandler(e) {
						if (document.visibilityState == 'visible') {
							//可见时计算隐藏了多少时间
							if (_hiddenTime) {
								_hiddenTimes.push(new Date().getTime() - _hiddenTime);
							}
						} else {
							//隐藏时立马发送数据
							_hiddenTime = new Date().getTime();
							this._sendUnloadLog();
							this.sendLogs(true);
						}
					},
					_beforeunloadHanlder: function _beforeunloadHanlder(e) {
						this._sendUnloadLog();
					},
					/**
      * 发送页面离开埋点,只触发一次
      * @private
      */
					_sendUnloadLog: function _sendUnloadLog() {
						if (!_isSendUnloadLog) {
							this.log('unloadComplete', null, Date.now(), 'unloadComplete'); //停留时间
							this.sendLogs(true); //页面卸载强制发送
							_isSendUnloadLog = true;
						}
					},
					_errorHandler: function _errorHandler(e) {
						//同样的错误日志只存储一次
						if (typeof _cacheErr[e.message + e.lineno.toString()] !== 'undefined') {
							return;
						}
						var extra = {
							lineNo: e.lineno,
							fileName: e.filename
						};
						_cacheErr[e.message + e.lineno.toString()] = true;
						this.log(e.message, extra, null, 'jsErr');
						this.sendErrorLog({
							lineNo: e.lineno,
							fileName: e.filename,
							message: e.message,
							logType: 'tracker_listen' //标识是系统采集还是开发者的手工日志
						});
					},
					/**
      * 用于统计时间轴的启动函数
      * @param name 该timeline的描述文字,必须和timelineEnd保持一致
      */
					timelineStart: function timelineStart(name) {
						if (typeof this._timelineMap[name] === 'undefined') {
							this._timelineMap[name] = new Date().getTime();
						} else {
							console.warn('重复定义"' + name + '"的时间统计.');
						}
					},
					/**
      * 用于统计时间轴的截止函数，统计完截止时间后算出spending时间，然后发送请求
      * @param name 该时间点的描述
      * @param status 用于描述当前时间点产生的结果状态，success:成功  failure:失败  timeout:超时
      * @param extra 需要额外传递的参数
      * @param type 日志分类  cstTimeline:自定义时间轴,cstTimepoint:自定义时间点,timeline:系统时间轴,timepoint:系统时间点,jsErr:JS错误日志。mtop:MTOP数据采集
      * @return this
      **/
					timelineEnd: function timelineEnd(name, status, extra, type) {
						var cfg;
						if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) == 'object') {
							cfg = name;
						} else {
							cfg = {
								name: name,
								status: status,
								extra: extra,
								type: type || 'cstTimeline'
							};
						}
						cfg.status = cfg.status || 'success';
						if (typeof this._timelineMap[cfg.name] === 'undefined') {
							console.warn('没有"' + cfg.name + '"时间点的定义');
							return this;
						}
						var _endTime = new Date().getTime();
						var timeline = {
							"name": cfg.name, //本次打点的描述
							"sta": cfg.status, //
							"st": this._timelineMap[cfg.name] - PAGE_START_TIME, //开始时间点
							"et": _endTime - PAGE_START_TIME, //结束时间点
							"sp": _endTime - this._timelineMap[cfg.name], //花费时间
							"tp": cfg.type
						};
						if (isObject(cfg.extra)) {
							//修改策略，附加数据放入独立字段
							timeline.extra = mix({}, cfg.extra, true);
						}
						delete this._timelineMap[name];
						this.addLog(timeline); //压入队列,等待一次性发送出去
						return this;
					},
					/**
      * 事件打点工具,用于记录某一个时间点发生的事情
      * @param name 时间名称
      * @param logTime 日志产生的系统时间 new Date().getTime();
      * @param extra 额外数据
      * @param type 额外数据
      * @returns {Tracker}
      */
					log: function log(name, extra, logTime, type) {
						logTime = logTime || new Date().getTime();
						type = type || 'cstLog';
						var timeline = {
							"name": name, //本次打点的描述
							"st": logTime - PAGE_START_TIME, //开始时间点
							"tp": type
						};
						//额外数据放入extra属性，之前是加"_"作为标识
						if (isObject(extra)) {
							timeline.extra = mix({}, extra, true);
						}

						this._saveNetstat(); //每次打日志检测是否有网络环境,没有就获取并存储
						this.addLog(timeline);
						return this;
					},

					/**
      * 页面首次渲染完成之后的打点,用于记录页面加载到可用时所花费的时间,加载完成之后会发送timelines
      * @param renderCompletedTime
      * @param extra
      * @returns {Tracker}
      */
					renderCompleted: function renderCompleted(renderCompletedTime, extra) {
						extra = extra || null;
						var self = this;
						if (self._isRenderCompleted) {
							return this;
						}
						var _endTime = renderCompletedTime || new Date().getTime();
						this.log("renderComplete", extra, _endTime, "renderComplete");
						self._isRenderCompleted = true;
						console.log('RenderComplete Point Compelete!');
						return this;
					},
					/**
      * 页面可交互时调用方法,统计可交互时间
      * @param interactCompletedTime
      * @param extra
      * @returns {Tracker}
      */
					interactCompleted: function interactCompleted(interactCompletedTime, extra) {
						extra = extra || null;
						var self = this;
						if (self._isInteractCompleted) {
							return this;
						}
						var _endTime = interactCompletedTime || new Date().getTime();
						this.log("interactComplete", extra, _endTime, "interactComplete");
						self._isInteractCompleted = true; //必须设置为true之后才能发送
						//this.sendLogs();
						console.log('InteractComplete Point Compelete!');
						return this;
					},
					/**
      * 交互可用后每10秒发送一次logs
      * @private
      */
					_autoSendLog: function _autoSendLog() {
						var self = this;
						this._autoSendTimer = setInterval(function () {
							self.sendLogs();
						}, 5000);
					},
					/**
      * 添加一个timeline对象
      * @param timeline
      */
					addLog: function addLog(timeline) {
						this._timelines.push(timeline);
						this.onLog && this.onLog(timeline); //用于调试工具调用
						return this;
					},
					/**
      * 清空队列的埋点数据
      * @private
      */
					_clearTimelines: function _clearTimelines() {
						this._timelines = [];
					},
					/**
      * 获取要发送对象的总长度
      * @param obj
      * @returns {Number}
      * @private
      */
					_jsonLen: function _jsonLen(obj) {
						return encodeURIComponent(JSON.stringify(obj)).length;
					},
					/**
      * 获取环境数据
      * @private
      */
					_getEnvData: function _getEnvData(reserver) {
						reserver.spm = this.getPageAB();
						reserver.isOff = this.isOffline();
						reserver.keepword = 1;
						reserver.guid = PAGE_START_TIME;
						reserver.nickName = getCookie('tracknick') || getCookie('cna');
						reserver.tracVer = this.version;
						reserver.projVer = this._getSrcVersion();
						reserver.gitRepos = this._getGitRepos();
						reserver.netstat = PERFORMANCE_INFO.netstat;
						reserver.dpr = typeof WIN.devicePixelRatio !== 'undefined' ? WIN.devicePixelRatio : '';
						reserver.sendTime = new Date().getTime();
						reserver.sendIndex = _sendIndex;
						reserver.pushVer = PERFORMANCE_INFO.pushVersion;
						return reserver;
					},
					/**
      * 加载网络状态并存储到变量
      * @private
      */
					_saveNetstat: function _saveNetstat() {
						if (!PERFORMANCE_INFO.netstat) {
							this._getNetstat(function (netstat) {
								PERFORMANCE_INFO.netstat = netstat;
							});
						}
					},
					/**
      * 将数组里面的timeline一次性发送出去,renderCompleted之前不能发送
      * @param immediately 是否强制发送
      * @return {Tracker}
      **/
					sendLogs: function sendLogs(immediately) {
						var self = this;
						var sendObj = {};
						var trackerPerformanceTime = WIN.trackerPerformanceTime;
						immediately = typeof immediately === 'undefined' ? false : immediately;

						//_isInteractCompleted之前，sendLogs不允许被调用
						if (!self._isInteractCompleted && !immediately) {
							return this;
						}
						this._getEnvData(sendObj); //每一个请求都带上基础环境数据

						// 以下数据确保只发送一次
						if (trackerPerformanceTime.trip_headerTime > 0) {
							//白屏时间统计
							var _tripHeaderTime = trackerPerformanceTime.trip_headerTime;
							trackerPerformanceTime.trip_headerTime = 0;
							this.log('headerComplete', null, _tripHeaderTime, 'headerComplete');
						}
						//domReady
						if (trackerPerformanceTime.readyTime > 0) {
							var _readyTime = trackerPerformanceTime.readyTime;
							trackerPerformanceTime.readyTime = 0;
							this.log('domComplete', null, _readyTime, 'domComplete');
						}
						//onload
						if (trackerPerformanceTime.loadTime > 0) {
							//onload之后才能采集performance埋点onload之后才能采集performance埋点，只采集一次
							if (_sendIndex == 0) {
								sendObj.perf = JSON.stringify(this.getPerformance());
							}

							var _loadTime = trackerPerformanceTime.loadTime;
							trackerPerformanceTime.loadTime = 0;
							this.log('loadComplete', null, _loadTime, 'loadComplete');

							//抽样10%统计 resourceTiming
							/*if (Math.random() * 100 <= 400) {
           if (WIN.performance && WIN.performance.getEntries) {
               setTimeout(function (){
                   var _resources = self.getResourceTiming();
                   self.sendLogs();
                   self.log("resourceTiming",{"request" : _resources ? JSON.stringify(_resources) : ""});
                   console.log(_resources);
                   self.sendLogs(true);
               },5000)
           }
       }*/
						}
						if (_sendIndex > 0 && this._timelines.length < 1) {
							//为空时不发送
							return this;
						}
						this._sendLogs(this._timelines, sendObj);
						this._clearTimelines(); //防止数据被重复发送,推送完后立即清空
						return this;
					},
					/**
      * 分片发送日志数据
      * @param logs
      * @param sendObj
      * @private
      */
					_sendLogs: function _sendLogs(logs, sendObj) {
						var _envLen = this._jsonLen(sendObj); //基础数据的长度
						var _readySendLogs = logs.concat();
						var _sendLogs = [];
						var self = this;
						var _send = function _send(_sendLogs, sendObj) {
							sendObj.logs = JSON.stringify(_sendLogs);
							console.log(sendObj);
							self.sendGoldLog(BASE_GOLD_KEY.timeline.key, BASE_GOLD_KEY.timeline.checkCode, sendObj);
							_sendIndex++;
							_sendLogs.length = 0;
						};
						//数据分片发送
						while (_readySendLogs.length > 0) {
							_sendLogs.push(_readySendLogs.shift());
							if (this._jsonLen(_sendLogs) + _envLen >= MAX_GET_REQUEST_LEN) {
								_send(_sendLogs, sendObj);
							}
						}
						if (_sendLogs.length > 0) {
							_send(_sendLogs, sendObj);
						}
					},
					/**
      * 提供一种通用的CLICK自定义黄金令箭埋点统计方案,指定可以数组,数组对象包含节点,黄金令箭信息,这些节点上出发的CLICK事件会进行黄金令箭埋点
      * @param golgLogList 是一个数组[{node: 'xx', goldCode: 'xx', checkCodeNum: 'xx', gokey: 'xx'}, {}, {}]
      */
					addGoldLogList: function addGoldLogList(golgLogList) {
						var self = this;
						var body = document.body;
						var meta = document.querySelector('meta[name="aplus-touch"]');
						var metaVal = meta ? meta.getAttribute('content') : 0;
						var eventType = metaVal == 1 ? 'touchstart' : 'click';

						for (var i = 0, len = golgLogList.length; i < len; i++) {
							var item = golgLogList[i];

							(function (item) {
								body.addEventListener(eventType, function () {
									var matches = document.querySelectorAll(item.node);
									if (!matches.length) return;

									var e = arguments[0] || window.event;
									var currentTarget = e.srcElement ? e.srcElement : e.target;
									for (var i = 0, len = matches.length; i < len; i++) {
										if (matches[i] == currentTarget || contains(matches[i], currentTarget)) {
											self.sendGoldLog(item.goldCode, item.checkCodeNum, item.gokey);
											break;
										}
									}
								});
							})(item);
						}
					},
					/**
      * 解决OAOP页面需要统计各个关键流程的PVUV时调用,先到SPM申请B点,
      * @param newPageId 页面的B点.
      */
					sendPageLog: function sendPageLog(newPageId) {
						if (newPageId) {
							document.querySelector('meta[name="data-spm"]').setAttribute('data-spm', '181.' + newPageId);
						}
						goldlog && goldlog.sendPV(); //暂时不考虑单页面应用
					},
					/**
      * 记录用户行为点
      * @param displayName 用户行为名称
      * @param gokey 业务埋点数据;string:xxx=xxx; 或者{xx:xx,xx:xx}
      */
					sendUserActionLog: function sendUserActionLog(displayName, gokey) {
						var self = this;
						var userAction = BASE_GOLD_KEY.userAction;

						if ((typeof gokey === 'undefined' ? 'undefined' : _typeof(gokey)) == "object") {
							gokey.displayName = displayName;
						} else {
							var displayNameStr = 'displayName=' + displayName;
							gokey = gokey ? gokey + '&' + displayNameStr : displayNameStr;
						}
						self.sendGoldLog(userAction.key, userAction.checkCode, gokey);
					},
					/**
      * 发送黄金令箭埋点
      * @param goldCode 申请的环境令箭串
      * @param checkCodeNum 环境令箭串校验码
      * @param gokey 业务埋点数据;string:xxx=xxx; 或者{xx:xx,xx:xx}
      */
					sendGoldLog: function sendGoldLog(goldCode, checkCodeNum, gokey, UTConfig) {
						var self = this;
						gokey = gokey || {};
						UTConfig = UTConfig || {};
						if ((typeof gokey === 'undefined' ? 'undefined' : _typeof(gokey)) == "object") {
							if (window._prism_lk) {
								gokey._prism_lk = JSON.stringify(window._prism_lk);
							}
							var gokeyStr = [];

							for (var key in gokey) {
								if (gokey.hasOwnProperty(key)) {
									var item = typeof gokey[key] !== 'undefined' ? String(gokey[key]) : '';
									gokeyStr.push(key + '=' + encodeURIComponent(item));
								}
							}
							gokey = gokeyStr.join('&');
						}
						gokey += '&spm-cnt=' + self._getPageSPM();
						self._goldlog(goldCode, gokey, UTConfig);
					},
					/**
      * 黄金令箭数据推送的基础方法
      * @param goldCode
      * @param gokey
      * @private
      */
					_goldlog: function _goldlog(goldCode, gokey, UTConfig) {
						var imgObj = new Image();
						var src = LOG_HOST + goldCode + '?';
						var query = ["cache=" + new Date().getTime(), "gmkey=", "gokey=" + encodeURIComponent(gokey)];

						imgObj.src = src + query.join('&');
						imgObj = null;

						UTConfig = UTConfig || {};
						// if AliApp use windVane
						if (isWindVane && WIN.WindVane) {

							var urlParams = location.search.slice(1);
							gokey = (gokey || "") + (urlParams ? "&_h5params=" + encodeURIComponent(urlParams) : "");
							var windVaneData = {},
							    data = {
								gmkey: "",
								gokey: gokey,
								isbeta: "9"
							},
							    logkeyargs;

							try {
								logkeyargs = JSON.stringify(data);
								if (logkeyargs == "{}") {
									logkeyargs = "";
								}
							} catch (err) {
								logkeyargs = "";
							}
							windVaneData["functype"] = UTConfig.eventId || '2101';
							windVaneData["logkey"] = "/" + goldCode;
							windVaneData["logkeyargs"] = logkeyargs;
							windVaneData["urlpagename"] = "";
							windVaneData["url"] = location.href;
							windVaneData["cna"] = getCookie('cna') || "";
							windVaneData["extendargs"] = "";
							windVaneData["isonepage"] = "";
							WIN.WindVane.call("WVTBUserTrack", "toUT", windVaneData);
						}
					},
					/**
      * 获取performance对象内容
      * 字段定义:http://www.w3.org/TR/2012/REC-navigation-timing-20121217/timing-overview.png
      * @returns {object}
      */
					getPerformance: function getPerformance() {
						if (!WIN.performance || !WIN.performance.timing) {
							return '';
						}
						var timing = WIN.performance.timing;
						var perf = {
							"redirect": timing.redirectEnd - timing.redirectStart,
							"appCache": timing.domainLookupStart - timing.fetchStart,
							"dns": timing.domainLookupEnd - timing.domainLookupStart,
							"tcp": timing.connectEnd - timing.connectStart,
							"request": timing.responseStart - timing.requestStart,
							"response": timing.responseEnd - timing.responseStart,
							"processing": timing.domComplete - timing.domLoading,
							"onLoad": timing.loadEventEnd - timing.loadEventStart,
							"fetchStart": timing.fetchStart,
							"domLoading": timing.domLoading,
							"_domReady": timing.domInteractive - timing.domLoading,
							"_loaded": timing.loadEventEnd - timing.domLoading,
							"_network": timing.responseEnd - timing.fetchStart
						};
						if (WIN.performance.memory) {
							mix(perf, WIN.performance.memory, true, "", false);
						}
						return perf;
					},
					/**
      * 获取请求书,请求时长等数据
      */
					getResourceTiming: function getResourceTiming() {
						var result = {};
						if (WIN.performance && WIN.performance.getEntries) {
							result.resources = WIN.performance.getEntries().map(function (req) {
								return {
									name: req.name,
									sp: Math.round(req.responseEnd - req.startTime)
								};
							});
							result.count = result.resources.length;
							return result;
						} else {
							return "";
						}
					},
					/**
      * 获取网络环境信息
      * @private
      */
					_getNetstat: function _getNetstat(cb) {
						var self = this;
						if (window.Bridge) {
							self.tripBridge = new window.Bridge();

							if (self.tripBridge.isAlitrip) {
								//去啊
								self.tripBridge.getWifiInfo(function (result) {
									if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object' && result.state) {
										//5.8.1之后支持获取网络环境
										cb(result.state.toLowerCase());
										return this;
									} else {
										cb('fail');
										return this;
									}
								});
							} else if (window.AlipayJSBridge) {
								var _aliplayNs = UA.match(/AlipayDefined\(nt\:(\d?.?\d?[A-Za-z|]+)\,/i); //支付宝在ua已经存在ns
								if (_aliplayNs && _aliplayNs.length >= 2) {
									cb(_aliplayNs[1].toLowerCase());
									return this;
								} else {
									cb('fail');
									return this;
								}
							} else if (self.tripBridge.isWindVane && window.WindVane) {
								//淘宝 http://h5.alibaba-inc.com/api/WindVane-API.html#网络检测_WVNetwork
								WIN.WindVane.call('WVNetwork', 'getNetworkType', {}, function (result) {
									if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object' && result.type) {
										cb(result.type.toLowerCase());
										return this;
									} else {
										cb('fail');
										return this;
									}
								});
							} else {
								cb('fail');
								return this;
							}
						} else {
							cb('fail');
							return this;
						}
					},

					/**
      * 获取页面SPMID
      */
					_getPageSPM: function _getPageSPM() {
						var self = this;

						//spm 值
						return self.getPageAB() + '.0.0';
					},
					/**
      *  获取项目版本号
      */
					_getSrcVersion: function _getSrcVersion() {
						var meta = document.querySelector('meta[name="alitrip-project-version"]');
						var metaVal = meta && meta.getAttribute('content');

						if (metaVal) {
							return metaVal;
						}

						// meta 取不到的情况下从 KISSY.Config 中取
						if (window.KISSY && KISSY.Config && KISSY.Config.version) {
							return KISSY.Config.version;
						}

						return "";
					},
					/**
      * 获取信鸽推送的活动页面版本号 <meta name="alitrip-push-verison" content="2015.1015.1010" />
      * @private
      */
					_getPushVersion: function _getPushVersion() {
						var metaNode = document.querySelector('meta[name="alitrip-push-version"]');
						if (metaNode) {
							return metaNode.getAttribute('content');
						} else {
							return "";
						}
					},
					/**
      * 获取页面所在Project的GIT仓库NAME
      * @private
      */
					_getGitRepos: function _getGitRepos() {
						/**
       * 去KISSY的packages获取GIT仓库的名称，H5有一个统一规范 "h5-xxx"
       * @returns {string}
       */
						var getGitReposByPackages = function getGitReposByPackages() {
							var result = "";
							var packages = "";
							if (WIN.KISSY && WIN.KISSY.Config && WIN.KISSY.Config.packages) {
								Object.keys(KISSY.Config.packages).some(function (name) {
									packages = KISSY.Config.packages[name];
									//匹配 http://g.alicdn.com/trip/h5-home/0.2.97/
									if (packages.uri) {
										var _matchResult = packages.uri.match(/.[com|cn]\/trip\/(h5\-[A-Za-z_-]+)/);
										if (_matchResult && _matchResult.length > 1) {
											result = _matchResult[1];
											return true;
										}
									}
								});
							}
							return result;
						};
						if (WIN.KISSY && KISSY.Config) {
							return KISSY.Config.gitReposName || getGitReposByPackages();
						} else {
							var meta = document.querySelector('meta[name="alitrip-project-name"]');
							var metaVal = meta && meta.getAttribute('content');
							return metaVal || "";
						}
					},
					getPageAB: function getPageAB() {
						var self = this;
						if (WIN.goldlog) {
							return WIN.goldlog.spm_ab.join('.');
						}
						var meta = document.querySelector('meta[name="data-spm"]');
						var metaCompatible = document.querySelector('meta[name="spm-id"]');
						var _body = document.body;
						if (meta) {
							var spmAB = meta.getAttribute('content');
							if (spmAB.indexOf('.') < 0) {
								spmAB = spmAB + '.' + (_body && _body.getAttribute('data-spm') || '');
							}
							return spmAB;
						} else if (metaCompatible) {
							spmAB = metaCompatible.getAttribute('content');
							if (spmAB.indexOf('.') < 0) {
								spmAB = spmAB + '.' + (_body && _body.getAttribute('data-spm') || '');
							}
							return spmAB;
						}

						return '0.0';
					},

					getEelementABCD: function getEelementABCD(element) {
						var elementABCD = { a: "0", b: "0", c: "0", d: "0" };

						if (WIN.g_SPM) {
							elementABCD = WIN.g_SPM.getParam(element);
						}

						if (element.tagName != 'A') {
							var locaid;
							var spmClick = element.getAttribute('data-spm-click');
							spmClick = spmClick ? spmClick.split(';')[1] : '';
							locaid = spmClick ? spmClick.split('=d')[1] : 0;
							elementABCD.d = locaid;
						}

						return elementABCD;
						//return {a: "0", b: "0", c: "0", d: "0"}
					},

					getEelementABCDForStr: function getEelementABCDForStr(element) {
						var self = this;
						var elementABCD = self.getEelementABCD(element);
						return [elementABCD.a, elementABCD.b, elementABCD.c, elementABCD.d].join('.');
					},
					/**
      * 判断是否为离线包
      * @returns {boolean}
      */
					isOffline: function isOffline() {
						if (typeof WIN._$isOffline$_ !== 'undefined') {
							return WIN._$isOffline$_ / 1;
						}

						var meta = document.querySelector('meta[name="alitrip-offline"]');
						var metaVal = meta ? meta.getAttribute('content') : 0;
						return metaVal / 1;
					},

					/**
      * 统计错误埋点日志,主要记录js报错的错误日志
      * @param errorInfo 是{}，包含信息
      *  errorInfo.lineNo 报错行号
      *  errorInfo.message 错误内容
      *  errorInfo.fileName 错误文件
      */
					sendErrorLog: function sendErrorLog(errorInfo) {
						var self = this;
						errorInfo.logType = errorInfo.logType || 'user_log';
						!errorInfo && (errorInfo = {});
						errorInfo.keepword = 1;
						self.sendGoldLog(BASE_GOLD_KEY.normalError.key, BASE_GOLD_KEY.normalError.checkCode, errorInfo);
					},
					/**
      * 发错自定义错误日志,Mtop可能用于排查问题,此错误客户端会劫持
      * @param errorInfo 是{}，包含信息{errorName: , errorMesage: ,errorDetail}
      */
					sendCustomErrorLog: function sendCustomErrorLog(errorInfo) {},

					/**
      * 发错自定义性能数据
      * @param performanceInfo  是{}，包含信息{loadTime}
      */
					sendCustomPerformanceLog: function sendCustomPerformanceLog(performanceInfo) {},
					/**
      * 发送性能数据，单页面应用没有好办法
      */
					recordPerformance: function recordPerformance() {
						/*var self = this;
      self._collectionPerformanceInfo();*/

					},
					/**
      * 收集性能数据
      * @private
      */
					_collectionPerformanceInfo: function _collectionPerformanceInfo() {},
					/**
      * 获取页面加载性能数据
      * @private
      */
					_getLoadPerformance: function _getLoadPerformance() {},
					/**
      * 发送自动定义性能信息
      */
					_sendCustomPerformance: function _sendCustomPerformance() {},
					/**
      * 发送自定义性能信息
      * @param {isOffline} 是否离线包
      */
					sendCustomPerformance: function sendCustomPerformance(isOffline) {},
					/**
      * 获取屏幕分辨率
      */
					_getDPI: function _getDPI() {},

					/**
      * 获取页面ID,主要用于区分是否离线包,不再建议使用
      * @private
      */
					_getPageId: function _getPageId() {},

					_getUtdid: function _getUtdid() {},

					_getUrlParam: function _getUrlParam(param, uri) {
						var value;

						uri = uri || WIN.location.href;
						uri = uri.match('#') ? uri.split('#')[1] : uri; // fixed by liuhuo.gk
						value = uri.match(new RegExp('[\?\&]' + param + '=([^\&\#]*)([\&\#]?)', 'i'));

						return value ? decodeURIComponent(value[1]) : value;
					},

					//记录用户在页面的停留时间
					recordVisibileTime: function recordVisibileTime() {
						this.log('recordVisibileTime Deprecated ', null, null, 'trac');
						console.warn('废弃方法');
					},
					/**
      * 废弃方法,机票还在使用
      * @param gokey
      */
					send: function send(gokey) {
						this.sendGoldLog('tbjipiao.100.1', 'H46866756', gokey);
					},

					/**
      * 废弃方法,机票还在使用
      * @param gokey
      */
					sendButton: function sendButton(gokey) {
						this.log('sendButton Deprecated ', null, null, 'trac');
						console.warn('sendButton Deprecated');
						this.sendGoldLog('tbjipiao.100.1', 'H46866756', gokey);
					},

					/**
      * 废弃方法,机票还在使用
      * @param gokey
      */
					sendPoint: function sendPoint(gokey) {
						this.sendGoldLog('tbjipiao.100.1', 'H46866756', gokey);
					},

					sendWindVane: function sendWindVane() {
						console.log('Deprecated');
					},

					sendAplus: function sendAplus() {
						console.log('Deprecated');
					},

					sendBridge: function sendBridge() {
						console.log('Deprecated');
					},

					performance: function performance() {
						console.log('Deprecated');
					},

					mtopError: function mtopError(option) {
						this.sendCustomErrorLog(option);
					},
					/**
      * 不推荐使用,统计开始时间
      * @param name
      */
					startMark: function startMark(name) {
						/*var self = this;
      self.markObj[name] = {
          beign: new Date().getTime()
      }*/

					},
					/**
      * 不推荐使用 统计结束时间
      * @param name
      */
					endMark: function endMark(name) {
						/*var self = this;
      var markTime = self.markObj[name];
       if (markTime) {
          markTime.end = new Date().getTime()
      }*/
					},
					/**
      * 不推荐使用,测量 markStar 和 markEnd 的时间差
      * @param name
      * @returns {number}
      */
					measure: function measure(name) {
						/*var self = this;
      var markTime = self.markObj[name];
       if (markTime) {
          var beginTime = markTime.beginTime || 0;
          var endTime = markTime.endTime || 0;
          return endTime - beginTime;
      }
      return 0;*/

					},
					/**
      * 不推荐使用,清空mark的打点数据
      * @param name
      */
					clearMark: function clearMark(name) {
						/*var self = this;
       if (name) {
          self.markObj[name] = null;
      } else {
          self.markObj = {};
      }*/
					}
				};

				if (!window.MT) {
					window.MT = {};
				}
				window.MT.Tracker = new Tracker();
				window.MT.Aplus = function (gokey) {
					window.MT.Tracker.send(gokey);
				};

				return window.MT.Tracker;
			}(document);

			window.KISSY && KISSY.add('tracker/index', function () {
				return window.MT.Tracker;
			});

			exports.default = Tracker;

			/***/
		}
		/******/])
	);
});
;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./components/tracker/build/index.js
 ** module id = 8
 ** module chunks = 0
 **/